import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController } from 'ionic-angular';
import { Storage } from '@ionic/storage';

import { BrandSelectorPage } from '../brand-selector/brand-selector';
import { TermsOfUsePage } from '../terms-of-use/terms-of-use';

@IonicPage()
@Component({
  selector: 'page-welcome',
  templateUrl: 'welcome.html',
})
export class WelcomePage {

  constructor(private storage: Storage, public navCtrl: NavController, public navParams: NavParams, public modalCtrl: ModalController) {}

  continue() {
    this.storage.set('welcome', 1);
    this.navCtrl.setRoot(BrandSelectorPage);
  }

  openTermsOfUse() {
    this.storage.get('current_brand').then((brand) => {
      let tosModal = this.modalCtrl.create(TermsOfUsePage, { showBackBtn: true }, { cssClass: brand.name });
      tosModal.present();
    });
  }

  ionViewDidLoad() {}

}



// WEBPACK FOOTER //
// ./src/pages/welcome/welcome.ts